import { Controller } from 'stimulus';
import events from 'lib/events';

export default class SearchAnalyticsController extends Controller {
  connect() {
    window.addEventListener(events.search.click, this.sendSearchClick);
    window.addEventListener(events.download_btn.initial_click, this.sendSearchDownload);

    if (this.isSearchResultsPage) {
      this.sendPageView();
    }
  }

  disconnect() {
    window.removeEventListener(events.search.click, this.sendSearchClick);
    window.removeEventListener(events.download_btn.initial_click, this.sendSearchDownload);
  }

  sendPageView() {
    window.navigator.sendBeacon('/api/internal/tracking/search/pageviews', this.pageViewFormData);
  }

  sendSearchClick = (event) => {
    const clickData = this.searchClickFormData(event);

    window.navigator.sendBeacon('/api/internal/tracking/search/clicks', clickData);

    // save search data in localStorage for tracking possible download event
    const searchJSON = {};
    clickData.forEach((value, key) => { searchJSON[key] = value; });

    window.localStorage.setItem(`resource-${event.detail.resourceId}`, JSON.stringify(searchJSON));
  }

  sendSearchDownload = (event) => {
    const downloadData = this.searchDownloadFormData(event);

    if (downloadData) {
      window.navigator.sendBeacon('/api/internal/tracking/search/downloads', downloadData);
    }
  }

  get csrfParam() {
    const csrfParamTag = document.querySelector('meta[name=csrf-param]');
    if (csrfParamTag) {
      return csrfParamTag.content;
    }

    return null;
  }

  get csrfToken() {
    const csrfTokenTag = document.querySelector('meta[name=csrf-token]');
    if (csrfTokenTag) {
      return csrfTokenTag.content;
    }

    return null;
  }

  get isSearchResultsPage() {
    if (document.querySelector('[data-search-results-count]')) {
      return true;
    }
    return false;
  }

  get pageViewFormData() {
    const formData = new FormData();
    formData.append(this.csrfParam, this.csrfToken);

    const fields = [
      'algo_version',
      'domain',
      'filters_used',
      'guid',
      'internal',
      'locale',
      'page',
      'pageview_guid',
      'pro',
      'referrer',
      'results_count',
      'split_test_name',
      'split_test_variant',
      'term',
      'type',
      'user_guid',
    ];

    fields.forEach((field) => {
      formData.append(field, this.element.getAttribute(`data-search-${field.replace(/_/g, '-')}`) || '');
    });

    return formData;
  }

  searchClickFormData(event) {
    const formData = this.pageViewFormData;
    formData.append('resource_id', event.detail.resourceId);
    formData.append('resource_position', event.detail.resourcePosition);
    formData.append('resource_pro', event.detail.resourcePro);
    return formData;
  }

  searchDownloadFormData(event) {
    if (!event.detail.guid) {
      // If we don't have the search guid, we don't want to track this download
      return null;
    }

    const formData = new FormData();

    Object.entries(event.detail).forEach(([key, value]) => {
      formData.append(key, value);
    });

    return formData;
  }
}
